import { render, staticRenderFns } from "./SaveAsTemplate.vue?vue&type=template&id=4f5aad64"
import script from "./SaveAsTemplate.vue?vue&type=script&lang=js"
export * from "./SaveAsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports